import { Expose } from "class-transformer";

export class StartPlanningBoardDto {
  @Expose()
  businessUnitId: string;

  @Expose()
  weekStartDate: string;
}
